import Axios from "axios";

import AuthApi from "app/api/auth";
import AppConfig from "app/config/app";
import { createAuthData, getAuthData, resetAuthData } from "app/services/auth";
import { getBaseUrl } from "app/utils/api";

function redirectToLogin() {
  return (window.location.href = "/");
}

function getInstance(skipAuth = false) {
  const auth = skipAuth ? null : getAuthData();
  const axiosInstance = Axios.create({
    baseURL: getBaseUrl(),
    timeout: AppConfig.timeout,
    headers: {
      "Content-Type": "application/json",
      Authorization:
        auth && auth.accessToken ? `Bearer ${auth.accessToken}` : undefined,
    },
  });
  axiosInstance.interceptors.response.use(
    response => response,
    async err => {
      if (
        err?.response?.status === 401 &&
        !err?.config?.url?.includes("/auth/refresh")
      ) {
        try {
          const authData = getAuthData();
          if (authData?.refreshToken) {
            try {
              const data = await AuthApi.refresh(authData.refreshToken);
              createAuthData(data);
              err.config.headers.Authorization = `Bearer ${data.accessToken}`;
              return Axios.request(err.config);
            } catch (e) {
              resetAuthData();
              return redirectToLogin();
            }
          }
          resetAuthData();
          return redirectToLogin();
        } catch (catchErr) {
          redirectToLogin();
          return Promise.reject(catchErr);
        }
      }
      return Promise.reject(err);
    }
  );
  return axiosInstance;
}

export default getInstance;
